<template>
  <div id="contact" ref="contact-section">
    <div id="stars"></div>
    <div id="stars2"></div>
    <div id="stars3"></div>
    <div class="contact-section">
      <div class="section-header">
        <h2>Contact Me</h2>
        <h3>
          I appreciate you visiting my website and would love to hear from you.
          <br />Do you have a project ideal? Star Wars fan theories? or just
          want to drop me a line?
        </h3>
        <p>Please fill out the form below (to see the alien)</p>
      </div>
      <ContactForm />
    </div>
    <div class="footer-mountains"></div>
  </div>
</template>

<script>
import ContactForm from "./ContactForm";
export default {
  components: {
    ContactForm,
  },
};
</script>

<style lang="scss">
@import "../scss/stars-background.scss";
@import "../scss/styles.scss";
#contact {
  background: radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%);
  overflow: hidden;
  .footer-mountains {
    width: 100%;
    height: 170px;
    background-repeat: repeat-x;
    background-position: 30% bottom;
    background-size: 800px 170px;
    background-image: url(../assets/images/mountains-white-sm.svg);
    position: relative;
    z-index: 10;
    margin-bottom: -1px;
  }
  .section-header {
    padding-top: 5rem;
    h2 {
      font-size: 3rem;
      @include md {
        font-size: 4rem;
      }
    }
    h3 {
      color: $mcf-blue;
      text-shadow: #000 0 3px 3px;
      text-align: center;
      margin: 1rem 0;
      @include md {
        font-size: 1.8;
      }
    }
    p {
      color: $white;
      text-shadow: #000 0 2px 4px;
      text-align: center;
      @include md {
        font-size: 1.2rem;
      }
    }
  }
}
</style>